import { useEffect } from "react";
import { parseHtmlWithPlaceholders } from "./editorHelpers/placeholderParser";

export const ArticleContent = ({ content, className }: { content: string; className?: string }) => {
    // 🔹 1. parse -> placeholder’lar vs. işleniyor
    const firstPass = parseHtmlWithPlaceholders(content);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // animasyonu başlat
                        entry.target.classList.add("animate-slide-up");
                        // sadece bir kez çalışsın
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.2, // %20'si görünür olunca başlasın
            }
        );

        const targets = document.querySelectorAll(".article-content > *"); // içteki tüm elementler
        targets.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <div
            className={className}
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                color: "var(--color-text)",
            }}
        >
            <article className="article-content">{firstPass}</article>
        </div>
    );
};

